import BlujayBcaUserLocationIndex from "@/components/blujay_bca/user_location/BlujayBcaUserLocationIndex.vue";

let routesBlujayBcaUserLocation = [
    {
        path: '',
        meta: {
            title: "Blujay Bca User Location",
        },
        name: "BlujayBcaUserLocationIndex",
        component: BlujayBcaUserLocationIndex
    },
     
   
      
]

export default routesBlujayBcaUserLocation
  